import ProductListTable from './productListTable.container';

export default ProductListTable